import React, { Fragment } from 'react'

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { marNotificationsAction } from '../../redux/actions/notificationsActions'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

dayjs.extend(relativeTime);





const NotificationsBlock = ({ notification }) => {

    const dispatch = useDispatch()

    const { loading } = useSelector(state => state.marknotifications)



    const handleDispatch = () => {


        dispatch(marNotificationsAction({ notification_id: notification.id }))
    }



    const handleLink = (target) => {

        if (target === "PRODUCT") {
            return `/products/single-product?id=${notification?.related_product_id}`
        }

        if (target === "ORDER") {
            return `/orders/order-details?order_id=${notification?.related_order_id}`
        }

        if (target === "REPORT") {
            return `/order-reports`
        }

        if (target === "USER") {
            return `/dashboard/user-details?user_id=${notification?.related_user_id}`
        }


    }


    



    return (
        <Fragment >

            <div className={`flex justify-between items-center py-[1vmax] px-[1vmax] mb-[1vmax] bg-white shadow-1 rounded-lg relative`}
                disabled={loading}
            >
                {notification?.is_read === 0 &&
                    <div className="w-[0.7vmax] aspect-square rounded-full bg-blue-500 absolute top-[1vmax] right-[1vmax]">
                    </div>
                }
                <div className="w-[15%] lg:w-[8%]">

                    <div className={`w-[4vmax] h-[4vmax] lg:w-[4vmax] lg:h-[4vmax] rounded-lg flex-center text-[3.2vmax] lg:text-[1.5vmax] my-[0.5vmax]
                            ${notification?.type === "INFO" && "text-blue-400 bg-blue-100"}
                            ${notification?.type === "WARNING" && "text-red-400 bg-red-100"}

                            `}>
                        {
                            notification?.type === "INFO" && <i className="fa-regular fa-bell "></i>
                        }
                        {
                            notification?.type === "WARNING" && <i className="fa-solid fa-exclamation-triangle "></i>
                        }

                    </div>
                </div>
                <div className="text-[1.2vmax] lg:text-[0.9vmax] font-3 font-[400] text-gray-800 w-[85%] lg:w-[90%] pr-[0.5vmax]">
                    <h3 className='text-[1.1vmax] font-3 font-bold capitalize' >{notification?.target}</h3>

                    {notification?.message}
                    <br />
                    <div className="flex justify-between mt-[0.5vmax]">

                        <span className='text-[1.2vmax] lg:text-[0.8vmax] text-gray-500' >
                            {dayjs(notification.created_at).fromNow()}
                        </span>
                        {notification?.is_read === 0 &&

                            <button
                                onClick={handleDispatch}
                                disabled={loading}
                                className={`text-[1.2vmax] lg:text-[0.8vmax] font-[600] text-green-500`}>
                                Mark as Read
                            </button>

                        }
                        <Link
                            to={handleLink(notification?.target)}
                            onClick={handleDispatch}
                            disabled={loading}
                            className={`text-[1.2vmax] lg:text-[0.8vmax] font-[600] text-blue-500`}>
                            View
                        </Link>
                    </div>

                </div>
            </div>
        </Fragment>
    )
}

export default NotificationsBlock